<template lang="pug">
.student-cards-module(:class="{ mp: isMp }")
  template(v-if="!isMp")
    CardCouponModule(
      title="学生购卡专区",
      :info="cards",
      :preparing="preparing",
      @btn="clickCard",
      @more="showMore"
    )
  template(v-else)
    RideCardList(
      ref="rideCardList"
      :channel-code="rideCardParams.channelCode"
      :platform="rideCardParams.platform"
      :code-env="rideCardParams.codeEnv"
      :city="rideCardParams.city"
      :token="rideCardParams.token"
      :version="rideCardParams.version"
      :tianqi="rideCardParams.tianqi"
      :show-reduce-money="true"
      :page-id="rideCardParams.pageId"
      :hlCashier="rideCardParams.hlCashier"
      :native="rideCardParams.Native"
      @paySuccess="paySuccess"
    )
  Confirm(
    v-if="confirmVisible",
    left-btn="暂不购买",
    right-btn="继续购买",
    append-to-body,
    @onLeft="cancel",
    @onRight="onConfirmRight",
    @close="cancel"
  )
</template>

<script>
import Toast from '@/components/toast';
import { getTWCards } from '@/api/card';
import { env, Native } from '@hb/NBridge/lib/h5';
import { CardService } from '@/service/card';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { RideCardList } from '@hb/RideCardComponent';
import config from '@/const/config';
import hlCashier from '@hb/h5-cashier-lite';
import CardCouponModule from './card-coupon-module';
import {
  getTokenAndLocation, getTWCardPlatform, tryCatch,
} from '../../../utils';
import { getVersion } from '../../../utils/systemCode';
import Confirm from '../../card-for-app/components/confirm';

export default {
  components: {
    CardCouponModule,
    Confirm,
    RideCardList,
  },
  data() {
    return {
      preparing: true,
      cards: [],
      confirmVisible: false,
      item: null,
      isMp: false,
      params: {
        actionOrigin: 'StudentsCenter',
        channelCode: 101022,
      },
      rideCardParams: {
        channelCode: '101022',
        pageId: 'APP_student_ok',
        tianqi: UBT,
        hlCashier,
        Native,
      },
    };
  },
  mounted() {
  },
  methods: {
    showMore() {
      UBT.clickButton({
        pageId: 'APP_student_ok',
        buttonName: 'card_more',
        categoryId: 'platform',
        businessInfo: {},
      });
    },
    async start() {
      const {
        token, cityCode, adCode, longitude: lng, latitude: lat,
      } = await getTokenAndLocation();
      if (env.isAliMP || env.isAliMPMonitor) {
        this.rideCardParams = {
          ...this.rideCardParams,
          ...{
            token,
            city: {
              cityCode, adCode, lng, lat,
            },
            platform: getTWCardPlatform(),
            version: await getVersion(),
            codeEnv: config.env,
          },
        };
        this.isMp = true;
      } else {
        const data = await getTWCards({
          token,
          adCode,
          cityCode,
          businessId: 0, // 单车
          channelCodes: [101022],
          platform: getTWCardPlatform(),
          version: await getVersion(),
        }).then((v) => tryCatch(() => v.data.packageGroups[0]), null).catch(() => null);
        this.preparing = false;
        if (data) {
          const { packages, ...others } = data;
          if (packages && packages.length) {
            Object.assign(this.params, others || {});
            this.cards = packages.map((item) => {
              const {
                showName, originPrice, cardBatchInfo, actualPrice,
              } = item;
              const currentPrice = tryCatch(() => actualPrice.finalPrice, item.purchasePrice);
              let diff = '';
              if (actualPrice) {
                const { discountValue, reduceAmount } = actualPrice;
                if (discountValue && reduceAmount) {
                  diff = `${discountValue}折后学生补贴${reduceAmount}元`;
                } else if (discountValue) {
                  diff = `${discountValue}折优惠`;
                } else if (reduceAmount) {
                  diff = `学生补贴${reduceAmount}元`;
                }
              }
              UBT.moduleExpose({
                pageId: 'APP_student_ok',
                categoryId: 'platform',
                moduleId: 'student_card',
                contentId: 'student_card',
                exposureTimes: 1,
                businessInfo: {
                  card_name: showName,
                },
              });
              const isAppOnly = tryCatch(() => cardBatchInfo.usePlatform === 0, false);
              return {
                title: showName,
                originPrice,
                corner: isAppOnly ? 'APP专享' : '',
                isAppOnly,
                diff,
                currentPrice,
                detail: item,
                isCard: true,
                btn: '购买',
              };
            });
          }
        }
      }
    },
    cancel() {
      this.confirmVisible = false;
    },
    goSuccess({ isAppOnly } = {}) {
      const query = {
        title: '哈啰学生卡购买成功',
      };
      if (!isAppOnly) {
        query.nohint = 1;
      }
      this.$router.push({
        path: '/card-for-app-success',
        query,
      });
    },
    onConfirmRight() {
      this.confirmVisible = false;
      CardService.buy(this.item.detail, this.params || {}).then(() => {
        this.goSuccess(this.item);
      });
    },
    async clickCard(item) {
      UBT.clickButton({
        pageId: 'APP_student_ok',
        buttonName: 'student_card',
        categoryId: 'platform',
        businessInfo: {
          card_name: item.title,
        },
      });
      if (!env.isEasyBikeApp && !env.isAliMP && !env.isAliMPMonitor) {
        Toast.show('暂不支持在此环境购买');
        return;
      }
      if (!item.isAppOnly) {
        CardService.buy(item.detail, this.params || {}).then(() => {
          this.goSuccess(item);
        });
        return;
      }
      this.item = item;
      this.confirmVisible = true;
    },
    paySuccess() {
      Toast.show('购买成功');
      this.$refs.rideCardList.reload();
    },
  },
};
</script>

<style lang="less" scoped>
.student-cards-module {
  &.mp {
    background: #f0f3f5 !important;
    box-shadow: none !important;
    padding: 0.16rem 0.12rem 0.08rem !important;
  }
}

</style>
